import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplay = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12H4C4 13.1 4.20833 14.1375 4.625 15.1125C5.04167 16.0875 5.6125 16.9375 6.3375 17.6625C7.0625 18.3875 7.9125 18.9625 8.8875 19.3875C9.8625 19.8125 10.9 20.025 12 20.025C14.2333 20.025 16.125 19.25 17.675 17.7C19.225 16.15 20 14.2583 20 12.025C20 9.79167 19.225 7.9 17.675 6.35C16.125 4.8 14.2333 4.025 12 4.025C10.5167 4.025 9.17083 4.3875 7.9625 5.1125C6.75417 5.8375 5.8 6.8 5.1 8H8V10H2V4H4V6C4.91667 4.78333 6.06667 3.8125 7.45 3.0875C8.83333 2.3625 10.35 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 12L9 16L9 8L16 12Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgReplay);
export default ForwardRef;
